<template>
  <div>
    <Dialog
      width="860px"
      :visible="renderData.create_visible"
      @close="closeDialog"
      :height="createRenderType == 'mobile' ? '95%' : '678px'"
      mobileRenderType="drawerDialog"
      customClass="create-model-dialog"
    >
      <div
        :class="`${createRenderType}-create-model-container create-model-container`"
      >
        <div class="title">{{ $$t("create.create_your_custom_model") }}</div>
        <div class="desc">
          {{
            createRenderType == "mobile"
              ? $$t("create.upload_issues_on_mobile")
              : $$t("create.personalized_model")
          }}
        </div>
        <div class="upload-box">
          <div class="flex">
            <div class="upload-text flex1">
              {{ $$t("create.upload_audio_dataset") }}
            </div>
            <div
              v-if="uploadList.length || loraUploadList.length"
              :class="show_total < maxLimit ? 'number' : 'number-limit'"
            >
              {{ show_total }} / {{ maxLimit }}
              <span v-if="!(show_total < maxLimit)"
                >( {{ $$t("create.maximum_files") }} )</span
              >
            </div>
          </div>
          <div class="upload-main">
            <AudioUpload
              @initEditData="doInitEditData"
              @deleteUpload="handleDeleteUpload"
            ></AudioUpload>
          </div>
        </div>
        <div class="model-name">
          <div class="prompt">
            {{ $$t("create.name_your_personal_model") }}
          </div>
          <div class="input">
            <el-input
              :style="{
                '--el-fill-color-blank': 'rgba(255, 255, 255, 0.1)',
                '--el-border-width': '0',
              }"
              :placeholder="$$t('create.name')"
              v-model="model_name"
              :maxlength="50"
              @blur="handleSaveName"
            ></el-input>
          </div>
        </div>
        <div class="model-btn">
          <Bubble
            :disabled="!(show_total < minLimit)"
            :content="$$t('create.at_least_files')"
            placement="top"
          >
            <Button
              :loading="isLoading"
              :disabled="!model_name || show_total < minLimit"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '48px',
                '--background':
                  'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover':
                  'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
                '--fontColorHover': '#000',
              }"
              @click="handleCreateModel"
            >
              {{ $$t("create.create_my_model") }}
            </Button>
          </Bubble>
        </div>
        <div
          @click="handleClickDisclaimer"
          class="model-tip tc"
          v-html="$$t('create.create_model_agreement')"
        ></div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  reactive,
  watch,
  getCurrentInstance,
} from "vue";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js";
import message from "@/components/functionCallComponent/message/message.js"
import Button from "@/components/basic/button/Button.vue";
import Bubble from "@/components/bubble/bubble.vue";
import AudioUpload from "./audioUpload.vue";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n;
const createLayoutStore = useCreateLayoutStore();
const modelDataStore = useModelDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const { uploadList, loraUploadList, model_name, show_total } =
  storeToRefs(modelDataStore);
const emits = defineEmits(["createModel"]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const renderData = reactive({
  create_visible: true,
});

const minLimit = 100;
const maxLimit = 200;

watch(
  () => {
    return props.visible;
  },
  (val) => {
    renderData.create_visible = props.visible;
  },
  {
    immediate: true,
  }
);

watch(
  () => {
    return renderData.create_visible;
  },
  () => {
    emits("update:visible", renderData.create_visible);
  },
  {
    immediate: true,
  }
);

const closeDialog = () => {
  renderData.create_visible = false;
};

const handleClickDisclaimer = (event) => {
  if (event.target.tagName === "SPAN") {
    window.open(window.location.origin + "/disclaimer", "_blank");
  }
};

const doInitEditData = (uuid) => {
  modelDataStore.reportUpload(uuid).then((res) => {
    if (res.code == 200) {
      modelDataStore.updateFileList(uuid, {
        id: res.data?.id,
        state: 3,
      });
      modelDataStore.addTotal();
    } else if (res.code == 6344) {
      message.error({
        position: "top",
        content: $$t("create.maximum_files"),
      })
      modelDataStore.deleteItem(uuid);
    }
  });
};

const handleDeleteUpload = (id, type, clllBack) => {
  if (type == "upload") {
    modelDataStore.deleteUploadItem(id, clllBack);
  } else {
    modelDataStore.deleteUploadSavedItem(id, clllBack);
  }
};

const handleSaveName = () => {
  modelDataStore.saveModelName();
};

const handleCreateModel = () => {
  emits("createModel");
  // modelDataStore.createModel().then(res => {

  // })
};
</script>

<style lang="scss">
.create-model-dialog {
  input {
    color: #fff;
    font-size: 14px;
    font-weight: normal;
    line-height: 48px;
  }
  input::placeholder {
    color: rgba(255, 255, 255, 0.4) !important;
  }
  .el-input__wrapper {
    box-shadow: none;
    border-radius: 8px;
    padding: 0 16px;
    height: 48px;
  }
  .el-input__wrapper:hover {
    box-shadow: none;
    // border-radius: 8px;
  }
  .el-input__wrapper.is-focus {
    box-shadow: none;
    // border-radius: 8px;
  }
}
</style>

<style lang="scss" scoped>
.create-model-dialog {
  .create-model-container {
    color: #fff;
    padding: 4px 40px 40px;
    .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
    }
    .desc {
      margin-top: 4px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.5);
    }
    .upload-box {
      margin-top: 20px;
      .upload-text {
        font-size: 16px;
        line-height: 20px;
      }
      .number-limit {
        font-size: 12px;
        line-height: 120%;
        color: #ff5f74;
      }
      .number {
        font-size: 12px;
        line-height: 120%;
        color: #94adff;
      }
      .upload-main {
        flex: 1;
        margin-top: 12px;
      }
    }
    .model-name {
      margin-top: 20px;
      color: #fff;
      .prompt {
        font-size: 16px;
        line-height: 20px;
      }
      .input {
        margin-top: 12px;
      }
    }
    .model-btn {
      flex-shrink: 0;
      margin-top: 20px;
      :deep(.el-button .el-icon.is-loading) {
        background-image: url("@/assets/img/loading-mini-white-3x.png") !important;
      }
    }
    .model-tip {
      color: rgba(255, 255, 255, 0.5);
      margin-top: 12px;
      font-size: 14px;
      line-height: 16px;
      :deep(span) {
        color: #fff;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .pc-create-model-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .upload-box {
      flex: 1;
      height: 0;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      .upload-text {
        font-size: 16px;
        line-height: 20px;
      }
      .upload-main {
        flex: 1;
        height: 0;
      }
      .number-limit {
        font-size: 12px;
        line-height: 120%;
        color: #ff5f74;
      }
      .number {
        font-size: 12px;
        line-height: 120%;
        color: #94adff;
      }
      .upload-main {
        flex: 1;
        margin-top: 12px;
      }
    }
  }

  .mobile-create-model-container {
    padding: 0 16px 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    .title {
      padding-right: 44px;
      font-size: 24px;
      line-height: 28px;
    }
    .desc {
      padding-right: 44px;
      margin-top: 4px;
      font-size: 14px;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.5);
    }
    .upload-box {
      margin-top: 16px;
      flex: 1;
      height: 0;
      display: flex;
      flex-direction: column;
      .upload-text {
        font-size: 14px;
      }
      .upload-main {
        flex: 1;
        height: 0;
        overflow-y: hidden;
      }
    }
    .model-name {
      flex-shrink: 0;
      .prompt {
        font-size: 14px;
      }
      .input {
        margin-top: 12px;
      }
    }
    .model-tip {
      font-size: 11px;
    }
  }
}
</style>